<div *ngIf="noTableData">
  <div class="col-4 offset-4 marTB8 noData">
    <h5 class="H5Header marL16 marT32 center">
      <strong name="nodata">No data available</strong>
    </h5>
  </div>
</div>
<div *ngIf="!noTableData">
  <mat-table class="onHover" [dataSource]="dataSource">
    <ng-container *ngFor="let column of columnDefs; let i = index" [cdkColumnDef]="column">
      <mat-header-cell class="relative" *cdkHeaderCellDef>
        <h5
          class="GreyLight widthFix"
          *ngIf="
            headers[i].toLowerCase() !== 'type' &&
            headers[i].toLowerCase() !== 'seekclarification' &&
            headers[i].toLowerCase() !== 'pendingclarification'
          "
          id="tableheader{{ headers[i] }}"
        >
          {{ headers[i] | titlecase }}
        </h5>
        <h5
          class="GreyLight widthFix"
          *ngIf="headers[i].toLowerCase() !== 'type' && headers[i].toLowerCase() === 'seekclarification'"
          id="tableheader{{ headers[i] }}"
        >
          Seek Clarification
        </h5>
        <h5
          class="GreyLight widthFix"
          *ngIf="headers[i].toLowerCase() !== 'type' && headers[i].toLowerCase() === 'pendingclarification'"
          id="tableheader{{ headers[i] }}"
        >
          Pending Clarification
        </h5>
      </mat-header-cell>
      <ng-container *ngIf="i === 0">
        <mat-cell
          class="relative"
          *cdkCellDef="let element"
          [ngClass]="i == 0 ? 'customClass' : 'defaultClass'"
          id="column{{ element[column] }}"
        >
          {{ element[column] }}
        </mat-cell>
      </ng-container>
      <ng-container *ngIf="i !== 0">
        <mat-cell
          class="relative"
          *cdkCellDef="let element"
          [ngClass]="i == 0 ? 'customClass' : 'defaultClass'"
          id="col{{ element[column] }}"
        >
          {{ getCellData(element[column]) }}
        </mat-cell>
      </ng-container>
    </ng-container>
    <tr>
      <mat-header-row *matHeaderRowDef="columnDefs"></mat-header-row>
    </tr>
    <tr>
      <mat-row *matRowDef="let row; columns: columnDefs"></mat-row>
    </tr>
  </mat-table>
</div>
